import { useEffect } from 'react'
import { useHistory } from 'react-router'

import commonRepo from '@/repository/common.repo'
import { fullModalRoutes, RouteName } from '@/router'
import modalService from '@/service/modal.service'

export const useSavePath = () => {
  const history = useHistory<{ ignorePathSave?: boolean }>()
  useEffect(() => {
    const unblock = history.block(({ pathname: to, state }, action) => {
      const from = history.location.pathname
      const [, fromHeader, fromSubHeader] = from.split('/')
      const [, toHeader, toSubHeader] = to.split('/')

      if (
        [RouteName.lesson, ...fullModalRoutes].includes(`/${fromHeader}`) ||
        state?.ignorePathSave
      ) {
        return
      }

      // 차단된 경로를 마지막 위치로 남기면 LNB 가 그 경로로 되돌아가고 다시 차단돼 영구 고착된다.
      // (외부 링크로 차단 경로에 들어왔다가 튕겨 나오는 순간이 이 경우다)
      // 아래 POP 처리는 저장과 별개 책임이므로 이 조건 밖에 둔다.
      if (commonRepo.permission.isRouteAllowed(from)) {
        if (fromHeader !== toHeader) {
          commonRepo.router.lastLocationMap.set(`/${fromHeader}`, from)
        } else if (fromSubHeader !== toSubHeader) {
          commonRepo.router.lastLocationMap.set(`/${fromHeader}/${fromSubHeader}`, from)
        }
      }

      if (action === 'POP') {
        if (modalService.modalList.length > 0) {
          modalService.closeModal()
          return false
        }
      }
    })
    return () => unblock()
  }, [history.location.pathname])
}
